<template>
	<div class="compUploadTemplate">
		<el-dialog title="上传模板" width="800px" :visible="dialogState" @close="close" :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false">
			<div class="formBox">
				<div class="formLine">
					<div class="formLable">模板类型：</div>
					<div class="formValue">
						<div class="typeBox">
							<div class="typeItem" :class="[templateType===item.value?'active':'']" v-for="(item,index) in [{value:2,label:'洗美'}, {value:6,label:'寄养'}, {value:5,label:'医疗服务'}, {value:8,label:'活体'}, {value:3,label:'病例'}]" :key="index" @click="selectTemplateType(item.value)">{{item.label}}</div>
						</div>
					</div>
				</div>
				<div class="formLine" style="align-items:initial">
					<div class="formLable">所用印章：</div>
					<div class="formValue">
						<div class="signatureBox">
							<div class="signatureItem" v-for="(item,index) in signatureList" :key="index" :class="[signatureId===item.id?'active':'']" @click="selectSignature(item)">
								<img class="signatureImg" :src="item.sealUrl">
								<div class="signatureItemName">{{item.sealName}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="formView">
					<div style="width: 100px;text-align: right;padding: 0 0px 0 0;">上传：</div>
					<div class="imgView">
						<div v-for="(item,index) in imageUrl" :key="index" class="imgItem">
							<img alt="" src="../../../assets/img/signature/word.png" v-if="imageUrl.length > 0" >
							<i class="el-icon-error closeBtn" v-if="imageUrl.length > 0" @click="handleDeleteImgClick(index)"></i>
						</div>
						<img style="width: 80px; height: 80px" src="../../../assets/img/signature/uploadFile.png" @click="handleUploadClick" v-if="imageUrl.length===0">
						<input type="file" ref="file" style="width: 0;height: 0;" @change="changeFile"/>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				dialogState:true,
				
				templateType:2,
				signatureId:'2',
				signatureList:[],
				imageUrl:[],
			}
		},
		computed:{
			
		},
		props:{
			
		},
		mounted(){
			this.getSignatureList()
		},
		methods: {
			// 取消
			close(){
				this.$emit("submit",{type:"close"})
			},
			// 提交
			submit(){
				if(this.imageUrl.length===0){
					this.$message({
						message: '请上传模板',
						type: 'error'
					});
					return ;
				}
				let params = {
					shopId:'',
					contractName:'',
					"contractType": this.templateType,  
					"sealId": this.signatureId,  // 印章id
					"contractUrl": this.imageUrl[0]  //合同附件
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/Contract/Insert', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit("submit",{type:"success"})
					}
				})
			},
			// 切换模板类型
			selectTemplateType(item){
				this.templateType = item;
			},
			// 切换印章
			selectSignature(item){
				this.signatureId = item.id;
			},
			//转移触发上传按钮
			handleUploadClick(){
				this.$refs.file.click()
			},
			//删除对应图片
			handleDeleteImgClick(index){
				this.imageUrl.splice(index,1)
			},
			//上传
			changeFile(e){
				var index= e.target.files[0].name.lastIndexOf(".");
				var ext = e.target.files[0].name.substr(index+1);
				var formData = new FormData();
				if(ext==='doc'||ext==='docx'){
					formData.append('file', e.target.files[0])
					this.$upload.uploadFile(formData).then(data => {
						if (data.timestamp) {
							this.imageUrl.push(data.url);
						}
					})
				}else{
					this.$message({
						message: '只能上传doc,docx格式的文件',
						type: 'error'
					});
					return ;
				}
				this.$refs.file.value = null
			},
			getSignatureList(){
				let params = {
					"sealType": 0, // 类型
					"sealState": 0,  // 状态
					"shopId": '',
					"pageIndex": 1,
					"pageSize": 100,
					"keyword": ""
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/Contract/Seal/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.signatureList = res.data.data;
						if(this.$public.isNull(this.signatureList)){
							this.signatureId = ''
						}else{
							this.signatureId = this.signatureList[0].id
						}
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
.compUploadTemplate{
	.formBox{
		padding-left:50px;
		.formLine{
			display: flex;align-items: center;padding:10px 0;
			.formLable{
				font-size: 14px;color: #2A2A2A;width:100px;text-align: right;vertical-align: middle;flex-shrink: 0;
			}
			.formValue{
				.typeBox{
					display: flex;
					.typeItem{
						padding:0 10px;box-sizing: border-box;height: 24px;line-height: 22px;text-align: center;margin-right: 15px;border:1px solid rgba(0, 0, 0, 0.15);border-radius: 2px;background-color: #fff;font-size: 14px;cursor: pointer;
						&.active{
							color:#fff;background-color: #1890FF;border-color:#1890FF;
						}
					}
				}
				.signatureBox{
					display: flex;flex-wrap: wrap;
					.signatureItem{
						width:90px;height: 116px;background-color: #fff;border:1px solid #e4e4e4;text-align: center;margin-right: 10px;cursor: pointer;
						&.active{
							border-color:#1890FF;
							.signatureItemName{
								background-color: #1890FF;color:#fff;
							}
						}
						.signatureImg{
							width:80px;height: 80px;padding-top:5px;padding-bottom: 5px;
						}
						.signatureItemName{
							width:100%;line-height: 24px;background-color: #e4e4e4;text-align: center;color:#2A2A2A;font-size: 12px;
						}
					}
				}
			}
		}
		.formView {
			display: flex;
			margin: 20px 0 10px 0;
			.imgView{
				flex: 1;
				.imgItem{
					position: relative;
					width: 80px; 
					height: 80px;
					margin-right:20px;
					margin-bottom: 10px;
					float: left;
					img{
						width: 100%;
						height: 100%;
					}
					.closeBtn{
						display: block;
						color: red;
						position: absolute;
						top: -10px;
						right: -10px;
						font-size: 20px;
						z-index: 5;
					}
				}
			}
		}
		.buttonLine{
			padding:50px 0 150px 100px;
		}
	}
}
</style>
